// npm
import { Link } from 'react-router-dom';
import styled from 'styled-components';

// atomic components
import BoxWrap from 'components/UI/molecules/BoxWrap';
import TitleWrap from 'components/UI/molecules/TitleWrap';
import Progress from 'components/UI/atoms/Progress';
import Grid from 'components/UI/atoms/Grid';
import Text from 'components/UI/atoms/Text';
import Button from 'components/UI/atoms/Button';
import ChannelIOButton from 'components/UI/organisms/ChannelIOButton';

// common
import { WAKEUP_FORM_DATA } from 'common/common.constatns';
import { WakeUp } from 'common/interface/props';

interface IProps {
  progress: number;
  jobId: string;
  message?: string;
  solType: WakeUp;
  successMessage: string;
  helpListOpen: boolean;
  setHelpListOpen: (helpListOpen: boolean) => void;
}

function Presenter({ progress, jobId, message, solType, successMessage, helpListOpen, setHelpListOpen }: IProps) {
  const color = solType === 'COUPANG' ? 'main' : 'wakeup';

  return (
    <>
      <TitleWrap title="상품 등록 진행현황" subject={`작업번호 : ${jobId}`} step={3} direction="row" />
      <BoxWrap>
        <BoxWrap.Bottom>
          <Grid display="flex" justifyContent="center">
            <Grid width={900} top={30}>
              <Text color={color} fontSize="3rem" fontWeight={100} textAlign="center">
                {progress}%
              </Text>

              <Grid top={10} />
              <Text textAlign="center" fontSize="0.88rem" dangerouslySetInnerHTML={{ __html: message || '' }}></Text>

              <Grid top={20} />
              <Progress progress={progress} color={color} />

              <Grid top={40} />
              <Text fontSize="0.9rem" fontWeight={500}>
                ※ 순차적으로 작업 중입니다. 바로 진행이 되지 않더라도 잠시만 기다려주세요.
              </Text>

              <Text
                fontSize="0.9rem"
                fontWeight={500}
                cursor="pointer"
                onClick={() => {
                  setHelpListOpen(!helpListOpen);
                }}
              >
                ※ 등록 불가한 상품 유형 보기
                <img src={`/images/arrow_down.svg`} style={{ paddingLeft: 7, transform: `rotateX(${helpListOpen ? '180deg' : '0deg'})` }} alt="" />
              </Text>

              {helpListOpen && (
                <>
                  <Grid top={10} />
                  <Text fontWeight={300} fontSize="0.88rem" whiteSpace={'pre-wrap'}>
                    {WAKEUP_FORM_DATA[solType].restrictionType}
                  </Text>
                </>
              )}

              {progress >= 100 && (
                <Grid top={40} textAlign="center">
                  {message === successMessage ? (
                    <>
                      <ButtonWrap>
                        <Grid left={10} right={10} width={220}>
                          <a href={`${WAKEUP_FORM_DATA[solType].adminUrl}`} target="_blank" rel="noreferrer">
                            <Button color="main" variant="outlined">
                              {WAKEUP_FORM_DATA[solType].name.type5}
                            </Button>
                          </a>
                        </Grid>

                        {solType === 'COUPANG' && (
                          <Grid left={10} right={10} width={200}>
                            <Link to="/GMPAdminLogin?utm_source=plto&utm_medium=btn&utm_campaign=wakeup&utm_content=complete_goplto" target="_blank">
                              <Button color="main" variant="contained">
                                주문 수집 하기
                              </Button>
                            </Link>
                          </Grid>
                        )}
                      </ButtonWrap>

                      {solType !== 'COUPANG' && (
                        <Grid top={20}>
                          <Text textAlign="center" color="wakeup" fontSize="1.1rem" fontWeight={400}>
                            작업결과에 대해 가입메일로 엑셀파일 발송했으니 확인 부탁드립니다.
                          </Text>
                        </Grid>
                      )}
                    </>
                  ) : (
                    <Link to={`/${solType.toLowerCase()}/job/shop-login`}>
                      <Button color="main" variant="outlined" width={200}>
                        작업 재요청
                      </Button>
                    </Link>
                  )}
                </Grid>
              )}
            </Grid>
          </Grid>
        </BoxWrap.Bottom>
      </BoxWrap>
      {solType === 'COUPANG' && <ChannelIOButton solType={solType} />}
    </>
  );
}

const ButtonWrap = styled.div`
  display: flex;
  justify-content: center;
`;

export default Presenter;
